// src/pages/system/SingleCustomCollection/details/ItemActions.jsx
import { useTranslation } from 'react-i18next'

export default function ItemActions({
	item,
	collectionId,
	onEdit,
	onDelete,
	onAddNew,
	onBack,
	deleting = false,
}) {
	const { t } = useTranslation()

	return (
		<div className="flex gap-3 px-6 pt-3 pb-6 justify-center">
			<button
				type="button"
				onClick={onEdit}
				className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md shadow-sm hover:bg-indigo-700">
				{t('singleCustomCollection.list.actions.edit')}
			</button>
			<button
				type="button"
				onClick={onDelete}
				disabled={deleting}
				className={`inline-flex items-center px-4 py-2 text-sm font-medium text-white rounded-md shadow-sm ${
					deleting ? 'bg-gray-400 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'
				}`}>
				{deleting ? t('singleCustomCollection.details.actions.deleting') : t('singleCustomCollection.list.actions.delete')}
			</button>
			<button
				type="button"
				onClick={onAddNew}
				className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md shadow-sm hover:bg-indigo-700">
				{t('singleCustomCollection.list.actions.addNew')}
			</button>
			<button
				type="button"
				onClick={onBack}
				className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50">
				{t('singleCustomCollection.details.actions.backToList')}
			</button>
		</div>
	)
}
